<template>
	<div class="modal-card large">
		<div class="modal-card-head">
			<div class="modal-card-title">Add existing aircraft</div>
			<div class="modal-close-button" @click="$emit('close')"></div>
		</div>
		<div class="modal-card-body">
			<div class="mx-4 my-4">
				<div class="columns">
					<div class="column">
						<Search @updateAircraft="aircraft = $event"></Search>
						<br /><br />
						<div v-if="aircraft.length > 0">
							<AircraftTable :Aircraft="aircraft"
										   Select
										   Name
										   Model
										   @addSelected="addSelectedToPortfolio($event)">
							</AircraftTable>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Search from "@/components/aircraft/search.vue";
	import AircraftTable from "@/components/aircraft/aircraftTable.vue";
	export default {
		components: {
			Search,
			AircraftTable
		},
		props: {
			PortfolioId: String
		},
		data() {
			return {
				aircraft: []
			}
		},
		methods: {
			addSelectedToPortfolio(aircraftIds) {
				this.$http.post("api/aircraft/existing/portfolio", { SelectedIds: aircraftIds, PortfolioId: this.PortfolioId })
					.then(resp => {
						if (resp.data != null && resp.data == true) {
							this.$buefy.toast.open({
								message: "Aircraft saved to portfolio.",
								type: "is-success"
							});
							this.$emit('close');
						} else {
							this.$buefy.toast.open({
								message: "Failed to save to portfolio.",
								type: "is-danger"
							});
						}
					}).catch(err => {
						console.error(err);
					})
			}
		}
	}
</script>
